<template>
  <div id="Resource" class="page">
    <div class="container">
      <div class="title">
        <img src="@/assets/img/setting.png" />
        <span>空间设置</span>
      </div>
      <div class="content-box">
        <div class="item-block">
          <span class="block-left">空间名称:</span>
          <span>{{ name }}</span>
        </div>
        <div class="item-block">
          <span class="block-left">所有者:</span>
          <span>{{ creatorName }}</span>
        </div>
        <div class="item-block">
          <span class="block-left">创建时间:</span>
          <span>{{ createTime }}</span>
        </div>
        <div class="item-block">
          <span class="block-left spaceBg">封面:</span>
          <img
            v-if="coverUrl"
            class="space-avstar"
            :src="$hosts.static(coverUrl)"
            alt=""
          />
          <img
            v-else
            class="space-avstar"
            :src="require('@/assets/img/spaceBg.png')"
            alt=""
          />
        </div>
        <div class="item-block">
          <span class="line-item"></span>
        </div>
        <div class="item-block">
          <el-button
            v-if="isOwner"
            type="primary"
            @click="editSpaces(spaceId)"
            >编辑信息</el-button
          >
          <el-button
            v-if="isOwner"
            type="primary"
            class="whiteBg"
            @click="disbandSpaces()"
            >解散空间</el-button
          >
          <el-button
            v-if="!isOwner"
            type="primary"
            class="whiteBg"
            @click="quitSpaces()"
            >退出空间</el-button
          >
        </div>
      </div>
    </div>
    <edit-space ref="editSpace" @modify-success="editOK" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EditSpace from '@/views/setting/EditSpace.vue'
export default {
  name: 'Message',
  props: {
    prop: {
      type: Object,
    },
    activeName: {
      type: String,
    },
  },
  components: {
    EditSpace
  },
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      name: '',
      creatorName: '',
      createTime: '',
      coverUrl: '',
      isOwner: false,
      showSpace: false,
      confirmLoading: false,
      shopLogoUrl: '',
      shopUrl: '',
      imgFilters: '.jpg,.png',
      dialogInfo: {
        name: '',
      },
      dialogForm: {},
      rules: {
        name: [
          { required: true, message: '请输入空间名称', trigger: 'blur' },
          { validator: this.customValidate, trigger: 'blur' }
        ],
      },
      activeApiCode: ''
    }
  },
  computed: {
    ...mapGetters({
      spacesDetail: 'classifySpace/spacesDetail',
    }),
  },
  async created() {
    await this.getSpacesDetail(this.spaceId)
    this.name = this.spacesDetail.name
    this.creatorName = this.spacesDetail.creatorName
    this.createTime = this.spacesDetail.createTime.slice(0, 10)
    this.coverUrl = this.spacesDetail.coverUrl
    this.isOwner = this.spacesDetail.isOwner
  },
  mounted() {},
  methods: {
    ...mapActions({
      getSpacesDetail: 'classifySpace/getSpacesDetail',
    }),
    // 编辑空间列表
    editSpaces(spaceId) {
      this.$refs.editSpace.openDialog(spaceId)
    },
    // 编辑空间列表
    editOK(res) {
      this.name = res.name
      this.creatorName = res.creatorName
      this.createTime = res.createTime.slice(0, 10)
      this.coverUrl = res.coverUrl
      this.isOwner = res.isOwner
    },
    // 解散空间列表
    async disbandSpaces() {
      await this.$api.resource.hasResources(this.spaceId).then(async(res) => {
        if (res === true) {
          this.$confirm('当前空间下存在资源/文件，请清空后操作', {
            confirmButtonText: '确定',
            showCancelButton: false,
            showClose: false,
            type: 'error',
          })
          return
        }
        await this.$api.file.hasFiles(this.spaceId).then((fileRes) => {
          if (res !== true && fileRes !== true) {
            this.$confirm('解散<span style="color: red;">不可恢复</span>,是否确认解散空间?', {
              confirmButtonText: '确定解散',
              cancelButtonText: '取消',
              dangerouslyUseHTMLString: true,
              showClose: false,
              type: 'warning',
            }).then(() => {
              this.$api.space.disbandSpaces(this.spaceId).then((res) => {
                if (res) {
                  this.$tracks({ event: 'disbandSpace', params: { g_c_space_id: this.spaceId }})
                  this.$router.push({ path: '/' })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消解散',
              })
            })
          } else {
            this.$confirm('当前空间下存在资源/文件，请清空后操作', {
              confirmButtonText: '确定',
              showCancelButton: false,
              showClose: false,
              type: 'error',
            })
          }
        })
      })
    },
    // 退出空间列表
    quitSpaces() {
      this.$confirm(
        '退出<span style="color: red;">不可撤销</span>,是否确认退出空间?',
        {
          confirmButtonText: '确定退出',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'warning',
        }
      )
        .then(() => {
          this.$api.space.quitSpaces(this.spaceId).then((res) => {
            if (res) {
              this.$tracks({ event: 'quitSpace', params: { g_c_space_id: this.spaceId }})
              this.$router.push({ path: '/' })
            }
          })
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="less" scoped>
.page {
  display: flex;
  .container {
    flex: 1;
  }
}
.content-box {
  padding: 16px 0 0 16px;
}
.item-block {
  display: table;
  margin-bottom: 16px;
  .block-left {
    width: 75px;
    display: inline-flex;
  }
  .line-item {
    display: inline-block;
    width: 498px;
    border-bottom: 1px solid #d2d9e3;
  }
}
.whiteBg {
  border: 1px solid #d2d9e3;
  background: #fff;
  color: #495f70;
}
.title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  width: 100%;
  border-bottom: 1px solid #d2d9e3;
  padding: 8px 16px;
  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
  span {
    font-family: Microsoft YaHei;
    font-size: 20px;
    font-weight: normal;
    line-height: 28px;
    display: flex;
    align-items: center;
    letter-spacing: 0em;
    color: #495f70;
  }
}
.item-block {
  img {
    border: 1px solid #d2d9e3;
    width: 400px;
    height: 225px;
    border-radius: 2px;
  }
  .spaceBg {
    position: relative;
    display: inline-block;
    top: -212px;
    left: 0;
  }
}
/deep/ .el-dialog__body {
  padding-bottom: 0;
  border-bottom: 1px solid #d2d9e3 !important;
}
/deep/ .el-form-item__label:not(required)::before {
  content: "*";
  color: transparent;
  margin-right: 4px;
}
.gou-upload {
  display: flex;
  align-items: flex-end;
  .gou-upload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    margin-left: 32px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
    }
  }
  .gou-reupload-item-image {
    width: 300px;
    height: 156px;
    background: rgba(225, 225, 235, 1);
    position: relative;
    text-align: center;
    & > img {
      width: 300px;
      height: 156px;
    }
    .gou-upload-item-image-operate {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 300px;
      background: rgba(35, 40, 50, 1);
      opacity: 0.5;
      text-align: center;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
      line-height: 16px;
      padding: 4px 0;
      & :hover {
        color: #39e9db;
      }
    }
  }
  .gou-upload-logo {
    border: 1px dashed #d2d9e3;
    cursor: pointer;
    width: 300px;
    height: 156px;
    background-color: #fafafa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    span {
      line-height: 10px;
    }
    .icon-icon_add {
      font-size: 12px;
      &::before {
        border: 2px solid rgba(76, 84, 114, 1);
        border-radius: 50%;
        padding: 2px;
      }
    }
  }
  .gou-upload-tips {
    margin-left: 16px;
  }
}
.img-msg {
  font-size: 12px;
  color: #495f70;
}
img {
  width: 300px;
  height: 156px;
}
</style>
<style>
  .el-message-box__btns > .el-button--primary {
    background: #fff;
    color: red;
    border-color: red;
  }
  .el-message-box__wrapper {
    top: -120px;
  }
</style>
